/**
 * Created by zhengyf on 2018.1.11.
 */

;(function () {

    // 原产地
    var COUNTRYS = [
        {value: 'AF', label: 'Afghanistan'},
        {value: 'ALA', label: 'Aland Islands'},
        {value: 'AL', label: 'Albania'},
        {value: 'GBA', label: 'Alderney'},
        {value: 'DZ', label: 'Algeria'},
        {value: 'AS', label: 'American Samoa'},
        {value: 'AD', label: 'Andorra'},
        {value: 'AO', label: 'Angola'},
        {value: 'AI', label: 'Anguilla'},
        {value: 'AQ', label: 'Antarctica'},
        {value: 'AG', label: 'Antigua and Barbuda'},
        {value: 'AR', label: 'Argentina'},
        {value: 'AM', label: 'Armenia'},
        {value: 'AW', label: 'Aruba'},
        {value: 'ASC', label: 'Ascension Island'},
        {value: 'AU', label: 'Australia'},
        {value: 'AT', label: 'Austria'},
        {value: 'AZ', label: 'Azerbaijan'},
        {value: 'BS', label: 'Bahamas'},
        {value: 'BH', label: 'Bahrain'},
        {value: 'BD', label: 'Bangladesh'},
        {value: 'BB', label: 'Barbados'},
        {value: 'BY', label: 'Belarus'},
        {value: 'BE', label: 'Belgium'},
        {value: 'BZ', label: 'Belize'},
        {value: 'BJ', label: 'Benin'},
        {value: 'BM', label: 'Bermuda'},
        {value: 'BT', label: 'Bhutan'},
        {value: 'BO', label: 'Bolivia'},
        {value: 'BA', label: 'Bosnia and Herzegovina'},
        {value: 'BW', label: 'Botswana'},
        {value: 'BV', label: 'Bouvet Island'},
        {value: 'BR', label: 'Brazil'},
        {value: 'IO', label: 'British Indian Ocean Territory'},
        {value: 'BN', label: 'Brunei Darussalam'},
        {value: 'BG', label: 'Bulgaria'},
        {value: 'BF', label: 'Burkina Faso'},
        {value: 'BI', label: 'Burundi'},
        {value: 'KH', label: 'Cambodia'},
        {value: 'CM', label: 'Cameroon'},
        {value: 'CA', label: 'Canada'},
        {value: 'CV', label: 'Cape Verde'},
        {value: 'KY', label: 'Cayman Islands'},
        {value: 'CF', label: 'Central African Republic'},
        {value: 'TD', label: 'Chad'},
        {value: 'CL', label: 'Chile'},
        {value: 'CN', label: 'China (Mainland)'},
        {value: 'CX', label: 'Christmas Island'},
        {value: 'CC', label: 'Cocos (Keeling) Islands'},
        {value: 'CO', label: 'Colombia'},
        {value: 'KM', label: 'Comoros'},
        {value: 'ZR', label: 'Congo, The Democratic Republic Of The'},
        {value: 'CG', label: 'Congo, The Republic of Congo'},
        {value: 'CK', label: 'Cook Islands'},
        {value: 'CR', label: 'Costa Rica'},
        {value: 'CI', label: 'Cote D&#39;Ivoire'},
        {value: 'HR', label: 'Croatia (local name: Hrvatska)'},
        {value: 'CU', label: 'Cuba'},
        {value: 'CY', label: 'Cyprus'},
        {value: 'CZ', label: 'Czech Republic'},
        {value: 'DK', label: 'Denmark'},
        {value: 'DJ', label: 'Djibouti'},
        {value: 'DM', label: 'Dominica'},
        {value: 'DO', label: 'Dominican Republic'},
        {value: 'TP', label: 'East Timor'},
        {value: 'EC', label: 'Ecuador'},
        {value: 'EG', label: 'Egypt'},
        {value: 'SV', label: 'El Salvador'},
        {value: 'GQ', label: 'Equatorial Guinea'},
        {value: 'ER', label: 'Eritrea'},
        {value: 'EE', label: 'Estonia'},
        {value: 'ET', label: 'Ethiopia'},
        {value: 'FK', label: 'Falkland Islands (Malvinas)'},
        {value: 'FO', label: 'Faroe Islands'},
        {value: 'FJ', label: 'Fiji'},
        {value: 'FI', label: 'Finland'},
        {value: 'FR', label: 'France'},
        {value: 'FX', label: 'France Metropolitan'},
        {value: 'GF', label: 'French Guiana'},
        {value: 'PF', label: 'French Polynesia'},
        {value: 'TF', label: 'French Southern Territories'},
        {value: 'GA', label: 'Gabon'},
        {value: 'GM', label: 'Gambia'},
        {value: 'GE', label: 'Georgia'},
        {value: 'DE', label: 'Germany'},
        {value: 'GH', label: 'Ghana'},
        {value: 'GI', label: 'Gibraltar'},
        {value: 'GR', label: 'Greece'},
        {value: 'GL', label: 'Greenland'},
        {value: 'GD', label: 'Grenada'},
        {value: 'GP', label: 'Guadeloupe'},
        {value: 'GU', label: 'Guam'},
        {value: 'GT', label: 'Guatemala'},
        {value: 'GGY', label: 'Guernsey'},
        {value: 'GN', label: 'Guinea'},
        {value: 'GW', label: 'Guinea-Bissau'},
        {value: 'GY', label: 'Guyana'},
        {value: 'HT', label: 'Haiti'},
        {value: 'HM', label: 'Heard and Mc Donald Islands'},
        {value: 'HN', label: 'Honduras'},
        {value: 'HK', label: 'Hong Kong'},
        {value: 'HU', label: 'Hungary'},
        {value: 'IS', label: 'Iceland'},
        {value: 'IN', label: 'India'},
        {value: 'ID', label: 'Indonesia'},
        {value: 'IR', label: 'Iran (Islamic Republic of)'},
        {value: 'IQ', label: 'Iraq'},
        {value: 'IE', label: 'Ireland'},
        {value: 'IM', label: 'Isle of Man'},
        {value: 'IL', label: 'Israel'},
        {value: 'IT', label: 'Italy'},
        {value: 'JM', label: 'Jamaica'},
        {value: 'JP', label: 'Japan'},
        {value: 'JEY', label: 'Jersey'},
        {value: 'JO', label: 'Jordan'},
        {value: 'KZ', label: 'Kazakhstan'},
        {value: 'KE', label: 'Kenya'},
        {value: 'KI', label: 'Kiribati'},
        {value: 'KS', label: 'Kosovo'},
        {value: 'KW', label: 'Kuwait'},
        {value: 'KG', label: 'Kyrgyzstan'},
        {value: 'LA', label: 'Lao People&#39;s Democratic Republic'},
        {value: 'LV', label: 'Latvia'},
        {value: 'LB', label: 'Lebanon'},
        {value: 'LS', label: 'Lesotho'},
        {value: 'LR', label: 'Liberia'},
        {value: 'LY', label: 'Libya'},
        {value: 'LI', label: 'Liechtenstein'},
        {value: 'LT', label: 'Lithuania'},
        {value: 'LU', label: 'Luxembourg'},
        {value: 'MO', label: 'Macau'},
        {value: 'MK', label: 'Macedonia'},
        {value: 'MG', label: 'Madagascar'},
        {value: 'MW', label: 'Malawi'},
        {value: 'MY', label: 'Malaysia'},
        {value: 'MV', label: 'Maldives'},
        {value: 'ML', label: 'Mali'},
        {value: 'MT', label: 'Malta'},
        {value: 'MH', label: 'Marshall Islands'},
        {value: 'MQ', label: 'Martinique'},
        {value: 'MR', label: 'Mauritania'},
        {value: 'MU', label: 'Mauritius'},
        {value: 'YT', label: 'Mayotte'},
        {value: 'MX', label: 'Mexico'},
        {value: 'FM', label: 'Micronesia'},
        {value: 'MD', label: 'Moldova'},
        {value: 'MC', label: 'Monaco'},
        {value: 'MN', label: 'Mongolia'},
        {value: 'MNE', label: 'Montenegro'},
        {value: 'MS', label: 'Montserrat'},
        {value: 'MA', label: 'Morocco'},
        {value: 'MZ', label: 'Mozambique'},
        {value: 'MM', label: 'Myanmar'},
        {value: 'NA', label: 'Namibia'},
        {value: 'NR', label: 'Nauru'},
        {value: 'NP', label: 'Nepal'},
        {value: 'NL', label: 'Netherlands'},
        {value: 'AN', label: 'Netherlands Antilles'},
        {value: 'NC', label: 'New Caledonia'},
        {value: 'NZ', label: 'New Zealand'},
        {value: 'NI', label: 'Nicaragua'},
        {value: 'NE', label: 'Niger'},
        {value: 'NG', label: 'Nigeria'},
        {value: 'NU', label: 'Niue'},
        {value: 'NF', label: 'Norfolk Island'},
        {value: 'KP', label: 'North Korea'},
        {value: 'MP', label: 'Northern Mariana Islands'},
        {value: 'NO', label: 'Norway'},
        {value: 'OM', label: 'Oman'},
        {value: 'Other', label: 'Other Country'},
        {value: 'PK', label: 'Pakistan'},
        {value: 'PW', label: 'Palau'},
        {value: 'PS', label: 'Palestine'},
        {value: 'PA', label: 'Panama'},
        {value: 'PG', label: 'Papua New Guinea'},
        {value: 'PY', label: 'Paraguay'},
        {value: 'PE', label: 'Peru'},
        {value: 'PH', label: 'Philippines'},
        {value: 'PN', label: 'Pitcairn'},
        {value: 'PL', label: 'Poland'},
        {value: 'PT', label: 'Portugal'},
        {value: 'PR', label: 'Puerto Rico'},
        {value: 'QA', label: 'Qatar'},
        {value: 'RE', label: 'Reunion'},
        {value: 'RO', label: 'Romania'},
        {value: 'RU', label: 'Russian Federation'},
        {value: 'RW', label: 'Rwanda'},
        {value: 'BLM', label: 'Saint Barthelemy'},
        {value: 'KN', label: 'Saint Kitts and Nevis'},
        {value: 'LC', label: 'Saint Lucia'},
        {value: 'MAF', label: 'Saint Martin'},
        {value: 'VC', label: 'Saint Vincent and the Grenadines'},
        {value: 'WS', label: 'Samoa'},
        {value: 'SM', label: 'San Marino'},
        {value: 'ST', label: 'Sao Tome and Principe'},
        {value: 'SA', label: 'Saudi Arabia'},
        {value: 'SCT', label: 'Scotland'},
        {value: 'SN', label: 'Senegal'},
        {value: 'SRB', label: 'Serbia'},
        {value: 'SC', label: 'Seychelles'},
        {value: 'SL', label: 'Sierra Leone'},
        {value: 'SG', label: 'Singapore'},
        {value: 'SK', label: 'Slovakia (Slovak Republic)'},
        {value: 'SI', label: 'Slovenia'},
        {value: 'SB', label: 'Solomon Islands'},
        {value: 'SO', label: 'Somalia'},
        {value: 'ZA', label: 'South Africa'},
        {value: 'SGS', label: 'South Georgia and the South Sandwich Islands'},
        {value: 'KR', label: 'South Korea'},
        {value: 'SS', label: 'South Sudan'},
        {value: 'ES', label: 'Spain'},
        {value: 'LK', label: 'Sri Lanka'},
        {value: 'SH', label: 'St. Helena'},
        {value: 'PM', label: 'St. Pierre and Miquelon'},
        {value: 'SD', label: 'Sudan'},
        {value: 'SR', label: 'Suriname'},
        {value: 'SJ', label: 'Svalbard and Jan Mayen Islands'},
        {value: 'SZ', label: 'Swaziland'},
        {value: 'SE', label: 'Sweden'},
        {value: 'CH', label: 'Switzerland'},
        {value: 'SY', label: 'Syrian Arab Republic'},
        {value: 'TW', label: 'Taiwan'},
        {value: 'TJ', label: 'Tajikistan'},
        {value: 'TZ', label: 'Tanzania'},
        {value: 'TH', label: 'Thailand'},
        {value: 'TLS', label: 'Timor-Leste'},
        {value: 'TG', label: 'Togo'},
        {value: 'TK', label: 'Tokelau'},
        {value: 'TO', label: 'Tonga'},
        {value: 'TT', label: 'Trinidad and Tobago'},
        {value: 'TN', label: 'Tunisia'},
        {value: 'TR', label: 'Turkey'},
        {value: 'TM', label: 'Turkmenistan'},
        {value: 'TC', label: 'Turks and Caicos Islands'},
        {value: 'TV', label: 'Tuvalu'},
        {value: 'UG', label: 'Uganda'},
        {value: 'UA', label: 'Ukraine'},
        {value: 'AE', label: 'United Arab Emirates'},
        {value: 'UK', label: 'United Kingdom'},
        {value: 'US', label: 'United States'},
        {value: 'UM', label: 'United States Minor Outlying Islands'},
        {value: 'UY', label: 'Uruguay'},
        {value: 'UZ', label: 'Uzbekistan'},
        {value: 'VU', label: 'Vanuatu'},
        {value: 'VA', label: 'Vatican City State (Holy See)'},
        {value: 'VE', label: 'Venezuela'},
        {value: 'VN', label: 'Vietnam'},
        {value: 'VG', label: 'Virgin Islands (British)'},
        {value: 'VI', label: 'Virgin Islands (U.S.)'},
        {value: 'WF', label: 'Wallis And Futuna Islands'},
        {value: 'EH', label: 'Western Sahara'},
        {value: 'YE', label: 'Yemen'},
        {value: 'YU', label: 'Yugoslavia'},
        {value: 'ZM', label: 'Zambia'},
        {value: 'EAZ', label: 'Zanzibar'},
        {value: 'ZW', label: 'Zimbabwe'},
        {value: 'CW', label: 'Curacao'},
        {value: 'SX', label: 'Sint Maarten'}
    ];
    var PROVINCE_MAP = {
        CN: [
            {"value": "ANH", "label": "Anhui"},
            {"value": "BEI", "label": "Beijing"},
            {"value": "CHO", "label": "Chongqing"},
            {"value": "FUJ", "label": "Fujian"},
            {"value": "GAN", "label": "Gansu"},
            {"value": "GUA", "label": "Guangdong"},
            {"value": "GUN", "label": "Guangxi"},
            {"value": "GUI", "label": "Guizhou"},
            {"value": "HAI", "label": "Hainan"},
            {"value": "HEB", "label": "Hebei"},
            {"value": "HEI", "label": "Heilongjiang"},
            {"value": "HEN", "label": "Henan"},
            {"value": "HUB", "label": "Hubei"},
            {"value": "HUN", "label": "Hunan"},
            {"value": "NEI", "label": "Inner Mongolia"},
            {"value": "JIA", "label": "Jiangsu"},
            {"value": "JIN", "label": "Jiangxi"},
            {"value": "JIL", "label": "Jilin"},
            {"value": "LIA", "label": "Liaoning"},
            {"value": "NIN", "label": "Ningxia"},
            {"value": "QIN", "label": "Qinghai"}, {"value": "SHA", "label": "Shaanxi"},
            {"value": "SHN", "label": "Shandong"},
            {"value": "SHG", "label": "Shanghai"},
            {"value": "SHX", "label": "Shanxi"},
            {"value": "SIC", "label": "Sichuan"},
            {"value": "TIA", "label": "Tianjin"},
            {"value": "XIZ", "label": "Tibet"},
            {"value": "XIN", "label": "Xinjiang"},
            {"value": "YUN", "label": "Yunnan"},
            {"value": "ZHE", "label": "Zhejiang"}
        ],
        KR: [
            {"value": "10127143", "label": "Busan"},
            {"value": "9292741", "label": "Chungcheongbuk-do"},
            {"value": "9292740", "label": "Chungcheongnam-do"},
            {"value": "10127142", "label": "Daegu"},
            {"value": "10127141", "label": "Daejeon"},
            {"value": "9290738", "label": "Gangwon-do"},
            {"value": "10127144", "label": "Gwangju"},
            {"value": "9289210", "label": "Gyeonggi-do"},
            {"value": "9289197", "label": "Gyeongsangbuk-do"},
            {"value": "9289196", "label": "Gyeongsangnam-do"},
            {"value": "10127102", "label": "Incheon"},
            {"value": "10127145", "label": "Jeju-do"},
            {"value": "9293426", "label": "Jeollabuk-do"},
            {"value": "9293425", "label": "Jeollanam-do"},
            {"value": "10127103", "label": "Seoul"},
            {"value": "10209537", "label": "Ulsan"},
            {"value": "100032000", "label": "Sejong"}
        ],
        US: [
            {"value": "1003", "label": "Alabama"},
            {"value": "1040", "label": "Alaska"},
            {"value": "1945", "label": "Arizona"},
            {"value": "1951", "label": "Arkansas"},
            {"value": "5599", "label": "California"},
            {"value": "7636", "label": "Colorado"},
            {"value": "7798", "label": "Connecticut"},
            {"value": "8831", "label": "Delaware"},
            {"value": "9130", "label": "District of Columbia"},
            {"value": "11032", "label": "Florida"},
            {"value": "12004", "label": "Georgia"},
            {"value": "13656", "label": "Hawaii"},
            {"value": "14713", "label": "Idaho"},
            {"value": "14808", "label": "Illinois"},
            {"value": "14882", "label": "Indiana"},
            {"value": "14987", "label": "Iowa"},
            {"value": "16121", "label": "Kansas"},
            {"value": "16480", "label": "Kentucky"},
            {"value": "19283", "label": "Louisiana"},
            {"value": "19840", "label": "Maine"},
            {"value": "20487", "label": "Maryland"},
            {"value": "20543", "label": "Massachusetts"},
            {"value": "21196", "label": "Michigan"},
            {"value": "21412", "label": "Minnesota"},
            {"value": "21502", "label": "Mississippi"},
            {"value": "21512", "label": "Missouri"},
            {"value": "21789", "label": "Montana"},
            {"value": "22869", "label": "Nebraska"},
            {"value": "23035", "label": "Nevada"},
            {"value": "23097", "label": "New Hampshire"},
            {"value": "23117", "label": "New Jersey"},
            {"value": "23132", "label": "New Mexico"},
            {"value": "23161", "label": "New York"},
            {"value": "23611", "label": "North Carolina"},
            {"value": "23624", "label": "North Dakota"},
            {"value": "24230", "label": "Ohio"},
            {"value": "24293", "label": "Oklahoma"},
            {"value": "24561", "label": "Oregon"},
            {"value": "25623", "label": "Pennsylvania"},
            {"value": "27664", "label": "Rhode Island"},
            {"value": "31410", "label": "South Carolina"},
            {"value": "31418", "label": "South Dakota"},
            {"value": "33025", "label": "Tennessee"},
            {"value": "33145", "label": "Texas"},
            {"value": "34626", "label": "Utah"},
            {"value": "35022", "label": "Vermont"},
            {"value": "35364", "label": "Virginia"},
            {"value": "35841", "label": "Washington"},
            {"value": "36208", "label": "West Virginia"},
            {"value": "36684", "label": "Wisconsin"},
            {"value": "36927", "label": "Wyoming"}
        ],
        UK: [
            {"value": "1", "label": "Aberdeenshire"},
            {"value": "2", "label": "Angus"},
            {"value": "3", "label": "Argyll"},
            {"value": "4", "label": "Avon"},
            {"value": "5", "label": "Ayrshire"},
            {"value": "6", "label": "Banffshire"},
            {"value": "7", "label": "Bedfordshire"},
            {"value": "8", "label": "Berkshire"},
            {"value": "9", "label": "Berwickshire"},
            {"value": "10", "label": "Buckinghamshire"},
            {"value": "125", "label": "Caerphilly"},
            {"value": "11", "label": "Caithness"},
            {"value": "12", "label": "Cambridgeshire"},
            {"value": "124", "label": "Cardiff"},
            {"value": "121", "label": "Carmarthenshire"},
            {"value": "13", "label": "Cheshire"},
            {"value": "14", "label": "Clackmannanshire"},
            {"value": "15", "label": "Cleveland"},
            {"value": "16", "label": "Clwyd"},
            {"value": "17", "label": "Cornwall"},
            {"value": "18", "label": "County Antrim"},
            {"value": "19", "label": "County Armagh"},
            {"value": "20", "label": "County Down"},
            {"value": "21", "label": "County Durham"},
            {"value": "22", "label": "County Fermanagh"},
            {"value": "23", "label": "County Londonderry"},
            {"value": "24", "label": "County Tyrone"},
            {"value": "25", "label": "Cumbria"},
            {"value": "26", "label": "Derbyshire"},
            {"value": "27", "label": "Devon"},
            {"value": "28", "label": "Dorset"},
            {"value": "29", "label": "Dumfriesshire"},
            {"value": "30", "label": "Dunbartonshire"},
            {"value": "31", "label": "Dyfed"},
            {"value": "32", "label": "East Lothian"},
            {"value": "33", "label": "East Sussex"},
            {"value": "34", "label": "Essex"},
            {"value": "35", "label": "Fife"},
            {"value": "126", "label": "Glasgow"},
            {"value": "36", "label": "Gloucestershire"},
            {"value": "127", "label": "Greater Manchester"},
            {"value": "62", "label": "Guernsey"},
            {"value": "37", "label": "Gwent"},
            {"value": "38", "label": "Gwynedd"},
            {"value": "39", "label": "Hampshire"},
            {"value": "40", "label": "Herefordshire"},
            {"value": "41", "label": "Hertfordshire"},
            {"value": "42", "label": "Inverness-Shire"},
            {"value": "43", "label": "Isle Of Arran"},
            {"value": "44", "label": "Isle Of Barra"},
            {"value": "45", "label": "Isle Of Benbecula"},
            {"value": "46", "label": "Isle Of Bute"},
            {"value": "47", "label": "Isle Of Canna"},
            {"value": "48", "label": "Isle Of Coll"},
            {"value": "49", "label": "Isle Of Colonsay"},
            {"value": "50", "label": "Isle Of Cumbrae"},
            {"value": "51", "label": "Isle Of Eigg"},
            {"value": "52", "label": "Isle Of Gigha"},
            {"value": "53", "label": "Isle Of Harris"},
            {"value": "54", "label": "Isle Of Iona"},
            {"value": "55", "label": "Isle Of Islay"},
            {"value": "56", "label": "Isle Of Jura"},
            {"value": "57", "label": "Isle Of Lewis"},
            {"value": "58", "label": "Isle Of Mull"},
            {"value": "59", "label": "Isle Of North Uist"},
            {"value": "60", "label": "Isle Of Rum"},
            {"value": "63", "label": "Isle Of Scalpay"},
            {"value": "64", "label": "Isle Of Skye"},
            {"value": "65", "label": "Isle Of South Uist"},
            {"value": "66", "label": "Isle Of Tiree"},
            {"value": "67", "label": "Isle Of Wight"},
            {"value": "68", "label": "Isles Of Scilly"},
            {"value": "61", "label": "Jersey"},
            {"value": "69", "label": "Kent"},
            {"value": "70", "label": "Kincardineshire"},
            {"value": "71", "label": "Kinross-Shire"},
            {"value": "72", "label": "Kirkcudbrightshire"},
            {"value": "73", "label": "Lanarkshire"},
            {"value": "74", "label": "Lancashire"},
            {"value": "75", "label": "Leicestershire"},
            {"value": "76", "label": "Lincolnshire"},
            {"value": "77", "label": "London"},
            {"value": "78", "label": "Merseyside"},
            {"value": "79", "label": "Mid Glamorgan"},
            {"value": "80", "label": "Middlesex"},
            {"value": "81", "label": "Midlothian"},
            {"value": "82", "label": "Morayshire"},
            {"value": "83", "label": "Nairnshire"},
            {"value": "123", "label": "Newport"},
            {"value": "84", "label": "Norfolk"},
            {"value": "85", "label": "North Humberside"},
            {"value": "86", "label": "North Yorkshire"},
            {"value": "87", "label": "Northamptonshire"},
            {"value": "88", "label": "Northumberland"},
            {"value": "89", "label": "Nottinghamshire"},
            {"value": "90", "label": "Orkney Isles"},
            {"value": "91", "label": "Oxfordshire"},
            {"value": "92", "label": "Peeblesshire"},
            {"value": "122", "label": "Pembrokeshire"},
            {"value": "93", "label": "Perthshire"},
            {"value": "94", "label": "Powys"},
            {"value": "95", "label": "Renfrewshire"},
            {"value": "96", "label": "Ross-Shire"},
            {"value": "97", "label": "Roxburghshire"},
            {"value": "98", "label": "Rutland"},
            {"value": "99", "label": "Selkirkshire"},
            {"value": "100", "label": "Shetland Islands"},
            {"value": "101", "label": "Shropshire"},
            {"value": "102", "label": "Somerset"},
            {"value": "103", "label": "South Glamorgan"},
            {"value": "104", "label": "South Humberside"},
            {"value": "105", "label": "South Yorkshire"},
            {"value": "106", "label": "Staffordshire"},
            {"value": "107", "label": "Stirlingshire"},
            {"value": "108", "label": "Suffolk"},
            {"value": "109", "label": "Surrey"},
            {"value": "110", "label": "Sutherland"},
            {"value": "111", "label": "Tyne And Wear"},
            {"value": "112", "label": "Warwickshire"},
            {"value": "113", "label": "West Glamorgan"},
            {"value": "114", "label": "West Lothian"},
            {"value": "115", "label": "West Midlands"},
            {"value": "116", "label": "West Sussex"},
            {"value": "117", "label": "West Yorkshire"},
            {"value": "118", "label": "Wigtownshire"},
            {"value": "119", "label": "Wiltshire"},
            {"value": "120", "label": "Worcestershire"}
        ],
        IN: [
            {"value": "7911143", "label": "Andaman and Nicobar Islands"},
            {"value": "1569", "label": "Andhra Pradesh"},
            {"value": "10101668", "label": "Arunachal Pradesh"},
            {"value": "2147", "label": "Assam"},
            {"value": "3922", "label": "Bihar"},
            {"value": "10122743", "label": "Chandigarh"},
            {"value": "7911144", "label": "Chhattisgarh"},
            {"value": "10122742", "label": "Dadra and Nagar Haveli"},
            {"value": "10122741", "label": "Daman and Diu"},
            {"value": "10122740", "label": "Delhi"},
            {"value": "7903620", "label": "Goa"},
            {"value": "7903232", "label": "Gujarat"},
            {"value": "13586", "label": "Haryana"},
            {"value": "14030", "label": "Himachal Pradesh"},
            {"value": "15393", "label": "Jammu and Kashmir"},
            {"value": "7911146", "label": "Jharkhand"},
            {"value": "16217", "label": "Karnataka"},
            {"value": "16494", "label": "Kerala"},
            {"value": "17968", "label": "Lakshadweep"},
            {"value": "19687", "label": "Madhya Pradesh"},
            {"value": "41826", "label": "Maharashtra"},
            {"value": "10122737", "label": "Manipur"},
            {"value": "10122739", "label": "Meghalaya"},
            {"value": "10107296", "label": "Mizoram"},
            {"value": "10122736", "label": "Nagaland"},
            {"value": "24593", "label": "Orissa"},
            {"value": "26311", "label": "Puducherry"},
            {"value": "26903", "label": "Punjab"},
            {"value": "27243", "label": "Rajasthan"},
            {"value": "30857", "label": "Sikkim"},
            {"value": "32665", "label": "Tamil Nadu"},
            {"value": "10107297", "label": "Tripura"},
            {"value": "34648", "label": "Uttar Pradesh"},
            {"value": "7911145", "label": "Uttarakhand"},
            {"value": "36115", "label": "West Bengal"},
            {"value": "100031981", "label": "Telangana"}
        ],
        TR: [
            {"value": "trProvince20100903", "label": "Adana"},
            {"value": "trProvince20100904", "label": "Adiyaman"},
            {"value": "trProvince20100905", "label": "Afyonkarahisar"},
            {"value": "trProvince20100906", "label": "Agri"},
            {"value": "trProvince20100907", "label": "Aksaray"},
            {"value": "trProvince20100908", "label": "Amasya"},
            {"value": "trProvince20100909", "label": "Ankara"},
            {"value": "trProvince20100910", "label": "Antalya"},
            {"value": "trProvince20100911", "label": "Ardahan"},
            {"value": "trProvince20100912", "label": "Artvin"},
            {"value": "trProvince20100913", "label": "Aydin"},
            {"value": "trProvince20100914", "label": "Balikesir"},
            {"value": "trProvince20100915", "label": "Bartin"},
            {"value": "trProvince20100916", "label": "Batman"},
            {"value": "trProvince20100917", "label": "Bayburt"},
            {"value": "trProvince20100918", "label": "Bilecik"},
            {"value": "trProvince20100919", "label": "Bingol"},
            {"value": "trProvince20100920", "label": "Bitlis"},
            {"value": "trProvince20100921", "label": "Bolu"},
            {"value": "trProvince20100922", "label": "Burdur"},
            {"value": "trProvince20100923", "label": "Bursa"},
            {"value": "trProvince20100924", "label": "Canakkale"},
            {"value": "trProvince20100925", "label": "Cankiri"},
            {"value": "trProvince20100926", "label": "Corum"},
            {"value": "trProvince20100927", "label": "Denizli"},
            {"value": "trProvince20100928", "label": "Diyarbakir"},
            {"value": "trProvince20100929", "label": "Duzce"},
            {"value": "trProvince20100930", "label": "Edirne"},
            {"value": "trProvince20100931", "label": "Elazig"},
            {"value": "trProvince20100932", "label": "Erzincan"},
            {"value": "trProvince20100933", "label": "Erzurum"},
            {"value": "trProvince20100934", "label": "Eskisehir"},
            {"value": "trProvince20100935", "label": "Gaziantep"},
            {"value": "trProvince20100936", "label": "Giresun"},
            {"value": "trProvince20100937", "label": "Gumushane"},
            {"value": "trProvince20100938", "label": "Hakkari"},
            {"value": "trProvince20100939", "label": "Hatay"},
            {"value": "trProvince201009140", "label": "Igdir"},
            {"value": "trProvince201009141", "label": "Isparta"},
            {"value": "trProvince201009142", "label": "Istanbul"},
            {"value": "trProvince201009143", "label": "Izmir"},
            {"value": "trProvince201009144", "label": "Kahramanmaras"},
            {"value": "trProvince201009145", "label": "Karabuk"},
            {"value": "trProvince201009146", "label": "Karaman"},
            {"value": "trProvince201009147", "label": "Kars"},
            {"value": "trProvince201009148", "label": "Kastamonu"},
            {"value": "trProvince201009149", "label": "Kayseri"},
            {"value": "trProvince20100950", "label": "Kilis"},
            {"value": "trProvince20100951", "label": "Kirikkale"},
            {"value": "trProvince20100952", "label": "Kirklareli"},
            {"value": "trProvince20100953", "label": "Kirsehir"},
            {"value": "trProvince20100954", "label": "Kocaeli"},
            {"value": "trProvince20100955", "label": "Konya"},
            {"value": "trProvince20100956", "label": "Kutahya"},
            {"value": "trProvince20100957", "label": "Malatya"},
            {"value": "trProvince20100958", "label": "Manisa"},
            {"value": "trProvince20100959", "label": "Mardin"},
            {"value": "trProvince20100960", "label": "Mersin"},
            {"value": "trProvince20100961", "label": "Mugla"},
            {"value": "trProvince20100962", "label": "Mus"},
            {"value": "trProvince20100963", "label": "Nevsehir"},
            {"value": "trProvince20100964", "label": "Nigde"},
            {"value": "trProvince20100965", "label": "Ordu"},
            {"value": "trProvince20100966", "label": "Osmaniye"},
            {"value": "trProvince20100967", "label": "Rize"},
            {"value": "trProvince20100968", "label": "Sakarya"},
            {"value": "trProvince20100969", "label": "Samsun"},
            {"value": "trProvince20100970", "label": "Sanliurfa"},
            {"value": "trProvince20100971", "label": "Siirt"},
            {"value": "trProvince20100972", "label": "Sinop"},
            {"value": "trProvince20100973", "label": "Sirnak"},
            {"value": "trProvince20100974", "label": "Sivas"},
            {"value": "trProvince20100975", "label": "Tekirdag"},
            {"value": "trProvince20100976", "label": "Tokat"},
            {"value": "trProvince20100977", "label": "Trabzon"},
            {"value": "trProvince20100978", "label": "Tunceli"},
            {"value": "trProvince20100979", "label": "Usak"},
            {"value": "trProvince20100980", "label": "Van"},
            {"value": "trProvince20100981", "label": "Yalova"},
            {"value": "trProvince20100982", "label": "Yozgat"},
            {"value": "trProvince20100983", "label": "Zonguldak"}
        ],
        MY: [
            {"value": "1", "label": "Johor"},
            {"value": "2", "label": "Kedah"},
            {"value": "3", "label": "Kelantan"},
            {"value": "4", "label": "Kuala Lumpur"},
            {"value": "5", "label": "Labuan"},
            {"value": "6", "label": "Melaka"},
            {"value": "7", "label": "Negeri Sembilan"},
            {"value": "17", "label": "Nilai"},
            {"value": "8", "label": "Pahang"},
            {"value": "9", "label": "Perak"},
            {"value": "10", "label": "Perlis"},
            {"value": "11", "label": "Pulau Pinang"},
            {"value": "12", "label": "Putrajaya"},
            {"value": "13", "label": "Sabah"},
            {"value": "16", "label": "Sarawak"},
            {"value": "14", "label": "Selangor"},
            {"value": "15", "label": "Terengganu"}
        ],
        VN: [
            {"value": "1", "label": "An Giang"},
            {"value": "2", "label": "Ba Ria-Vung Tau"},
            {"value": "3", "label": "Bac Giang"},
            {"value": "4", "label": "Bac Kan"},
            {"value": "5", "label": "Bac Lieu"},
            {"value": "6", "label": "Bac Ninh"},
            {"value": "7", "label": "Ben Tre"},
            {"value": "8", "label": "Binh Dinh"},
            {"value": "9", "label": "Binh Duong"},
            {"value": "10", "label": "Binh Phuoc"},
            {"value": "11", "label": "Binh Thuan"},
            {"value": "12", "label": "Ca Mau"},
            {"value": "13", "label": "Can Tho"},
            {"value": "14", "label": "Cao Bang"},
            {"value": "15", "label": "Da Nang"},
            {"value": "16", "label": "Dak Lak"},
            {"value": "17", "label": "Dak Nong"},
            {"value": "18", "label": "Dien Bien"},
            {"value": "19", "label": "Dong Nai"},
            {"value": "20", "label": "Dong Thap"},
            {"value": "21", "label": "Gia Lai"},
            {"value": "22", "label": "Ha Giang"},
            {"value": "23", "label": "Ha Nam"},
            {"value": "24", "label": "Hanoi"},
            {"value": "25", "label": "Ha Tinh"},
            {"value": "26", "label": "Hai Duong"},
            {"value": "27", "label": "Hai Phong"},
            {"value": "28", "label": "Ho Chi Minh City"},
            {"value": "29", "label": "Hau Giang"},
            {"value": "30", "label": "Hoa Binh"},
            {"value": "31", "label": "Hung Yen"},
            {"value": "32", "label": "Khanh Hoa"},
            {"value": "33", "label": "Kien Giang"},
            {"value": "34", "label": "Kon Tum"},
            {"value": "35", "label": "Lai Chau"},
            {"value": "36", "label": "Lam Dong"},
            {"value": "37", "label": "Lang Son"},
            {"value": "38", "label": "Lao Cai"},
            {"value": "39", "label": "Long An"},
            {"value": "40", "label": "Nam Dinh"},
            {"value": "41", "label": "Nghe An"},
            {"value": "42", "label": "Ninh Binh"},
            {"value": "43", "label": "Ninh Thuan"},
            {"value": "44", "label": "Phu Tho"},
            {"value": "45", "label": "Phu Yen"},
            {"value": "46", "label": "Quang Binh"},
            {"value": "47", "label": "Quang Nam"},
            {"value": "48", "label": "Quang Ngai"},
            {"value": "49", "label": "Quang Ninh"},
            {"value": "50", "label": "Quang Tri"},
            {"value": "51", "label": "Soc Trang"},
            {"value": "52", "label": "Son La"},
            {"value": "53", "label": "Tay Ninh"},
            {"value": "54", "label": "Thai Binh"},
            {"value": "55", "label": "Thai Nguyen"},
            {"value": "56", "label": "Thanh Hoa"},
            {"value": "57", "label": "Thua Thien Hue"},
            {"value": "58", "label": "Tien Giang"},
            {"value": "59", "label": "Tra Vinh"},
            {"value": "60", "label": "Tuyen Quang"},
            {"value": "61", "label": "Vinh Long"},
            {"value": "62", "label": "Vinh Phuc"},
            {"value": "63", "label": "Yen Bai"}
        ],
        TH: [
            {"value": "1", "label": "Mae Hong Son"},
            {"value": "2", "label": "Ratchaburi"},
            {"value": "3", "label": "Chiang Mai"},
            {"value": "4", "label": "Phetchaburi"},
            {"value": "5", "label": "Chiang Rai"},
            {"value": "6", "label": "Prachuap Khiri Khan"},
            {"value": "7", "label": "Phayao"},
            {"value": "8", "label": "Nan"},
            {"value": "9", "label": "Chai Nat"},
            {"value": "10", "label": "Lamphun"},
            {"value": "11", "label": "Sing Buri"},
            {"value": "12", "label": "Lampang"},
            {"value": "13", "label": "Lop Buri"},
            {"value": "14", "label": "Phrae"},
            {"value": "15", "label": "Ang Thong"},
            {"value": "16", "label": "Phra Nakhon Si Ayuttaya"},
            {"value": "17", "label": "Uttaradit"},
            {"value": "18", "label": "Saraburi"},
            {"value": "19", "label": "Tak"},
            {"value": "20", "label": "Pathum Thani"},
            {"value": "21", "label": "Sukhothai"},
            {"value": "22", "label": "Nonthaburi"},
            {"value": "23", "label": "Phitsanulok"},
            {"value": "24", "label": "Bangkok"},
            {"value": "25", "label": "Kamphaeng Phet"},
            {"value": "26", "label": "Samut Prakan"},
            {"value": "27", "label": "Phichit"},
            {"value": "28", "label": "Samut Songkhram"},
            {"value": "29", "label": "Uthai Thani"},
            {"value": "30", "label": "Samut Sakhon"},
            {"value": "31", "label": "Nakhon Sawan"},
            {"value": "32", "label": "Nakhon Pathom"},
            {"value": "33", "label": "Phetchabun"},
            {"value": "34", "label": "Nakhon Nayok"},
            {"value": "35", "label": "Loei"},
            {"value": "36", "label": "Prachin Buri"},
            {"value": "37", "label": "Udon Thani"},
            {"value": "38", "label": "Sa Kaew"},
            {"value": "39", "label": "Nongbua Lumphoo"},
            {"value": "40", "label": "Cha Choeng Sao"},
            {"value": "41", "label": "Nong Khai"},
            {"value": "42", "label": "Chon Buri"},
            {"value": "43", "label": "Sakon Nakhon"},
            {"value": "44", "label": "Rayong"},
            {"value": "45", "label": "Nakhon Phanom"},
            {"value": "46", "label": "Chanthaburi"},
            {"value": "47", "label": "Mukdahan"},
            {"value": "48", "label": "Trat"},
            {"value": "49", "label": "Kalasin"},
            {"value": "50", "label": "Maha Sarakham"},
            {"value": "51", "label": "Chumphon"},
            {"value": "52", "label": "Khon Kaen"},
            {"value": "53", "label": "Ranong"},
            {"value": "54", "label": "Chaiyaphum"},
            {"value": "55", "label": "Surat Thani"},
            {"value": "56", "label": "Roi Et"},
            {"value": "57", "label": "Phang Nga"},
            {"value": "58", "label": "Phuket"},
            {"value": "59", "label": "Nakhon Ratchasima"},
            {"value": "60", "label": "Krabi"},
            {"value": "61", "label": "Buri Ram"},
            {"value": "62", "label": "Nakhon Si Thammarat"},
            {"value": "63", "label": "Surin"},
            {"value": "64", "label": "Phatthalung"},
            {"value": "65", "label": "Si Sa Ket"},
            {"value": "66", "label": "Trang"},
            {"value": "67", "label": "Ubon Ratchathani"},
            {"value": "68", "label": "Satun"},
            {"value": "69", "label": "Umnad Chareun"},
            {"value": "70", "label": "Song Khla"},
            {"value": "71", "label": "Yasothon"},
            {"value": "72", "label": "Pattani"},
            {"value": "73", "label": "Yala"},
            {"value": "74", "label": "Kanchanaburi"},
            {"value": "75", "label": "Narathiwat"},
            {"value": "76", "label": "Suphan Buri"}
        ]
    };

    // 计量单位
    var MEASURE_UNITS = ["Acre/Acres", "Ampere/Amperes", "Bag/Bags", "Barrel/Barrels", "Blade/Blades", "Box/Boxes", "Bushel/Bushels", "Carat/Carats", "Carton/Cartons", "Case/Cases", "Centimeter/Centimeters", "Chain/Chains", "Combo/Combos", "Cubic Centimeter/Cubic Centimeters", "Cubic Foot/Cubic Feet", "Cubic Inch/Cubic Inches", "Cubic Meter/Cubic Meters", "Cubic Yard/Cubic Yards", "Degrees Celsius", "Degrees Fahrenheit", "Dozen/Dozens", "Dram/Drams", "Fluid Ounce/Fluid Ounces", "Foot/Feet", "Forty-Foot Container", "Furlong/Furlongs", "Gallon/Gallons", "Gill/Gills", "Grain/Grains", "Gram/Grams", "Gross", "Hectare/Hectares", "Hertz", "Inch/Inches", "Kiloampere/Kiloamperes", "Kilogram/Kilograms", "Kilohertz", "Kilometer/Kilometers", "Kiloohm/Kiloohms", "Kilovolt/Kilovolts", "Kilowatt/Kilowatts", "Liter/Liters", "Long Ton/Long Tons", "Megahertz", "Meter/Meters", "Metric Ton/Metric Tons", "Mile/Miles", "Milliampere/Milliamperes", "Milligram/Milligrams", "Millihertz", "Milliliter/Milliliters", "Millimeter/Millimeters", "Milliohm/Milliohms", "Millivolt/Millivolts", "Milliwatt/Milliwatts", "Nautical Mile/Nautical Miles", "Ohm/Ohms", "Ounce/Ounces", "Pack/Packs", "Pair/Pairs", "Pallet/Pallets", "Parcel/Parcels", "Perch/Perches", "Piece/Pieces", "Pint/Pints", "Plant/Plants", "Pole/Poles", "Pound/Pounds", "Quart/Quarts", "Quarter/Quarters", "Rod/Rods", "Roll/Rolls", "Set/Sets", "Sheet/Sheets", "Short Ton/Short Tons", "Square Centimeter/Square Centimeters", "Square Foot/Square Feet", "Square Inch/Square Inches", "Square Meter/Square Meters", "Square Mile/Square Miles", "Square Yard/Square Yards", "Stone/Stones", "Strand/Strands", "Ton/Tons", "Tonne/Tonnes", "Tray/Trays", "Twenty-Foot Container", "Unit/Units", "Volt/Volts", "Watt/Watts", "Wp", "Yard/Yards"];

    // 计量单位-对象数组
    var MEASURE_UNITS_OBJ_ARRAY = [{
        "label": "Acre/Acres",
        "value": "26"
    }, {"label": "Ampere/Amperes", "value": "27"}, {"label": "Bag/Bags", "value": "1"}, {
        "label": "Barrel/Barrels",
        "value": "19"
    }, {"label": "Blade/Blades", "value": "91"}, {"label": "Box/Boxes", "value": "28"}, {
        "label": "Bushel/Bushels",
        "value": "18"
    }, {"label": "Carat/Carats", "value": "90"}, {"label": "Carton/Cartons", "value": "29"}, {
        "label": "Case/Cases",
        "value": "30"
    }, {"label": "Centimeter/Centimeters", "value": "31"}, {
        "label": "Chain/Chains",
        "value": "32"
    }, {"label": "Combo/Combos", "value": "92"}, {
        "label": "Cubic Centimeter/Cubic Centimeters",
        "value": "33"
    }, {"label": "Cubic Foot/Cubic Feet", "value": "34"}, {
        "label": "Cubic Inch/Cubic Inches",
        "value": "35"
    }, {"label": "Cubic Meter/Cubic Meters", "value": "13"}, {
        "label": "Cubic Yard/Cubic Yards",
        "value": "36"
    }, {"label": "Degrees Celsius", "value": "37"}, {
        "label": "Degrees Fahrenheit",
        "value": "38"
    }, {"label": "Dozen/Dozens", "value": "14"}, {
        "label": "Dram/Drams",
        "value": "39"
    }, {"label": "Fluid Ounce/Fluid Ounces", "value": "40"}, {
        "label": "Foot/Feet",
        "value": "41"
    }, {"label": "Forty-Foot Container ", "value": "88"}, {
        "label": "Furlong/Furlongs",
        "value": "42"
    }, {"label": "Gallon/Gallons", "value": "15"}, {"label": "Gill/Gills", "value": "43"}, {
        "label": "Grain/Grains",
        "value": "44"
    }, {"label": "Gram/Grams", "value": "17"}, {"label": "Gross", "value": "87"}, {
        "label": "Hectare/Hectares",
        "value": "45"
    }, {"label": "Hertz", "value": "46"}, {"label": "Inch/Inches", "value": "47"}, {
        "label": "Kiloampere/Kiloamperes",
        "value": "48"
    }, {"label": "Kilogram/Kilograms", "value": "16"}, {
        "label": "Kilohertz",
        "value": "49"
    }, {"label": "Kilometer/Kilometers", "value": "10"}, {
        "label": "Kiloohm/Kiloohms",
        "value": "50"
    }, {"label": "Kilovolt/Kilovolts", "value": "51"}, {
        "label": "Kilowatt/Kilowatts",
        "value": "52"
    }, {"label": "Liter/Liters", "value": "22"}, {"label": "Long Ton/Long Tons", "value": "9"}, {
        "label": "Megahertz",
        "value": "53"
    }, {"label": "Meter/Meters", "value": "8"}, {
        "label": "Metric Ton/Metric Tons",
        "value": "7"
    }, {"label": "Mile/Miles", "value": "54"}, {
        "label": "Milliampere/Milliamperes",
        "value": "55"
    }, {"label": "Milligram/Milligrams", "value": "24"}, {
        "label": "Millihertz",
        "value": "56"
    }, {"label": "Milliliter/Milliliters", "value": "57"}, {
        "label": "Millimeter/Millimeters",
        "value": "58"
    }, {"label": "Milliohm/Milliohms", "value": "59"}, {
        "label": "Millivolt/Millivolts",
        "value": "60"
    }, {"label": "Milliwatt/Milliwatts", "value": "61"}, {
        "label": "Nautical Mile/Nautical Miles",
        "value": "62"
    }, {"label": "Ohm/Ohms", "value": "63"}, {"label": "Ounce/Ounces", "value": "6"}, {
        "label": "Pack/Packs",
        "value": "21"
    }, {"label": "Pair/Pairs", "value": "5"}, {"label": "Pallet/Pallets", "value": "86"}, {
        "label": "Parcel/Parcels",
        "value": "64"
    }, {"label": "Perch/Perches", "value": "65"}, {"label": "Piece/Pieces", "value": "4"}, {
        "label": "Pint/Pints",
        "value": "66"
    }, {"label": "Plant/Plants", "value": "85"}, {"label": "Pole/Poles", "value": "67"}, {
        "label": "Pound/Pounds",
        "value": "3"
    }, {"label": "Quart/Quarts", "value": "68"}, {"label": "Quarter/Quarters", "value": "69"}, {
        "label": "Rod/Rods",
        "value": "70"
    }, {"label": "Roll/Rolls", "value": "71"}, {"label": "Set/Sets", "value": "20"}, {
        "label": "Sheet/Sheets",
        "value": "89"
    }, {"label": "Short Ton/Short Tons", "value": "2"}, {
        "label": "Square Centimeter/Square Centimeters",
        "value": "72"
    }, {"label": "Square Foot/Square Feet", "value": "73"}, {
        "label": "Square Inch/Square Inches",
        "value": "74"
    }, {"label": "Square Meter/Square Meters", "value": "12"}, {
        "label": "Square Mile/Square Miles",
        "value": "75"
    }, {"label": "Square Yard/Square Yards", "value": "76"}, {
        "label": "Stone/Stones",
        "value": "77"
    }, {"label": "Strand/Strands", "value": "84"}, {"label": "Ton/Tons", "value": "11"}, {
        "label": "Tonne/Tonnes",
        "value": "78"
    }, {"label": "Tray/Trays", "value": "79"}, {
        "label": "Twenty-Foot Container",
        "value": "83"
    }, {"label": "Unit/Units", "value": "25"}, {"label": "Volt/Volts", "value": "80"}, {
        "label": "Watt/Watts",
        "value": "81"
    }, {"label": "Wp", "value": "82"}, {"label": "Yard/Yards", "value": "23"}]

    // 时间单位
    var TIME_UNITS = [
        {
            label: 'Day',
            value: 'Day'
        },
        {
            label: 'Quarter',
            value: 'Quarter'
        },
        {
            label: 'Week',
            value: 'Week'
        },
        {
            label: 'Month',
            value: 'Month'
        },
        {
            label: 'Year',
            value: 'Year'
        }
    ];

    // 货币种类
    var CURRENCY = ["USD", "GBP", "RMB", "EUR", "AUD", "CAD", "CHF", "JPY", "HKD", "NZD", "SGD", "NTD", "Other"];

    angular
        .module('DSSXAPP')
        .constant('CURRENCY', CURRENCY)
        .constant('TIME_UNITS', TIME_UNITS)
        .constant('COUNTRYS', COUNTRYS)
        .constant('PROVINCE_MAP', PROVINCE_MAP)
        .constant('MEASURE_UNITS', MEASURE_UNITS)
        .constant('MEASURE_UNITS_OBJ_ARRAY', MEASURE_UNITS_OBJ_ARRAY);

})();
